<!-- 无数据展示 -->
<template>
  <div class="empty-box">
    <img :src="src"/>
    <p>{{message}}</p>
  </div>
</template>

<script>
  export default {
    props:{
      src:{
        type:String,
        default:"/static/image/empty.png"
      },
      message:{
        type:String,
        default:"暂无数据"
      },
    },
    name: 'empty-data-image',
    data () {
      return {}
    },
    mixins: [tableBase],
    methods: {},
    mounted () {
    }
  }
</script>

<style lang="less" scoped>
  .empty-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #FFF;
    min-height: 120px;
    padding-bottom: 20px;
    img{
      padding-top: 30px;
      width: 20vw;
      height: 20vw;
    }
    p{
      font-weight: bold;
    }
  }
</style>
